import { Component, Input, OnInit } from '@angular/core';
import { BackendAlarm } from '../../../../alarm/alarm-definitions/backend-alarm';
import { MiproDataAlarm } from '../../../../alarm/alarm-definitions/mipro-data.alarm';
import { AlarmMessage } from '../../../../alarm/alarm-message';
import { TrainCategory } from '../../common/train';
import { TabId } from '../../train-info/train-info/train-info.component';
import { getDefaultTabIdForAlarmType } from '../../utils/train.utils';

type VRAlarm = Exclude<BackendAlarm, MiproDataAlarm>;

@Component({
  selector: 'qm-general-train-alarm-list-item',
  templateUrl: './general-train-alarm-list-item.component.html',
  styleUrls: ['./general-train-alarm-list-item.component.scss']
})
export class GeneralTrainAlarmListItemComponent implements OnInit {

  @Input() public alarm: AlarmMessage<VRAlarm>;
  public tripNumber: string;
  public tripDate: string;
  public trainCategory: string;
  public openTab: TabId;

  constructor() { }

  ngOnInit(): void {
    if (!this.alarm) {
      return;
    }
    this.tripNumber = this.alarm.metadata.payload.tripNumber
    this.trainCategory = this.getTrainCategoryForAlarm(this.alarm.metadata);
    this.tripDate = this.getTripDateForAlarm(this.alarm.metadata);
    this.openTab = getDefaultTabIdForAlarmType(this.alarm.metadata.type);
  }

  /**
   * The tripDates are named inconsistently between dependency alarms and other alarms
   */
  getTripDateForAlarm(alarm: VRAlarm): string {
    switch (alarm.type) {
      case 'vrVoltageAlert':
      case 'vrOverheating':
      case 'trainDeparture':
      case 'vrTrainStopped':
      case 'vrWheelAlert':
        return alarm.payload.tripDate;
      case 'vrShiftConflict':
      case 'vrTrainConflict':
        return alarm.payload.trainDate;
    }
  }

  getTrainCategoryForAlarm(alarm: VRAlarm): TrainCategory {
    switch (alarm.type) {
      case 'trainDeparture':
      case 'vrTrainStopped':
        return alarm.payload.trainCategory;
      case 'vrShiftConflict':
      case 'vrTrainConflict':
        return alarm.payload.trainCategory;
      default:
        return '';
    }
  }

}
